/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import "devbridge-autocomplete";

/*------------------------------------*\
    AUTOCOMPLETE MODULE
\*------------------------------------*/
class Autocomplete {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var serviceUrl = '/api/search/uk';

        if (window.location.href == 'https://www.cogentinternational.co.uk') {
            var serviceUrl = '/api/search/international';
        }

        if (window.location.href == 'https://cogentinternational.jfdstaging.co.uk') {
            var serviceUrl = '/api/search/international';
        }

        $('.js-search-input').autocomplete({
            serviceUrl: serviceUrl,
            appendTo: $('.js-search-wrapper'),
            onSelect: function (suggestion) {
                window.location.href = suggestion.url
            },
            transformResult: function(response){
                return {
                    suggestions: $.map(JSON.parse(response).data, function(dataItem) {
                        return {
                            value: dataItem.title,
                            url: dataItem.url
                        };
                    })
                };
            }
        });
    }
}

export default Autocomplete;
